import request from '@/utils/request'

// 分页查询回收预约单
export function pageRecycleOrder(data) {
  return request({
    url: '/biz/admin/recycle/order/page',
    method: 'post',
    data: data
  })
}

// 回收预约单详情
export function getRecycleOrder(data) {
  return request({
    url: '/biz/admin/recycle/order/detail',
    method: 'post',
    data: data
  })
}

// 回收预约单报价
export function quoteRecycleOrder(data) {
  return request({
    url: '/biz/admin/recycle/order/quote',
    method: 'post',
    data: data
  })
}

// 回收预约单结算(打款至用户钱包)
export function settleRecycleOrder(data) {
  return request({
    url: '/biz/admin/recycle/order/settle',
    method: 'post',
    data: data
  })
}
